import { render, staticRenderFns } from "./AdditionalService.vue?vue&type=template&id=5153e3e1&scoped=true&"
import script from "./AdditionalService.vue?vue&type=script&lang=js&"
export * from "./AdditionalService.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalService.vue?vue&type=style&index=0&id=5153e3e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5153e3e1",
  null
  
)

export default component.exports